import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseUrl } from '../../../shared/urls/base.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { AppConstants } from '../../../shared/constants/constants'
import { BaseService } from '../../../shared/services/base.service';
import { FormBuilder} from '@angular/forms';
import { DialogService } from '../../../shared/services/dialog.service';
import { MdDialog } from '@angular/material';
import { AuthService } from '../../../shared/services/auth.service';
@Component({
  selector: 'app-active',
  templateUrl: './active-link.component.html'
})
export class ActiveLinkComponent implements OnInit {
  public appConstants = AppConstants;
  authConfig = BaseUrl.AUTH_CONFIG;
  public messageText: string;
  public messageType: string;
  userId: string;
  public isSubmit = false;
  constructor(private router: Router,
    private activeRouter: ActivatedRoute,
    private baseService: BaseService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialog: MdDialog,
    public dialogServie: DialogService) {
  }
  ngOnInit() {
    this.userId = this.activeRouter.snapshot.queryParams[this.appConstants.activeLink.userId];
    const token = this.activeRouter.snapshot.queryParams[this.appConstants.activeLink.token];
    
    if (this.userId && token) {
      const activeUser = {
        userId: this.userId,
        token: token,
        isCheckLogout: false,
        callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
      };
      this.baseService.postData(UserUrl.EMAIL_CONFIRM_URL, activeUser).subscribe(
        (result) => {
          if (result) {
            console.log(result);
            const data = result.json();
            this.messageText = data['message'];
            this.messageType = data['type'];
          }
        },
        (error) => {
        }        
      );
    }
  }
   
  createPassword()
  {    
    this.router.navigate(["/create-password", this.userId]);
  }
  login() {
    this.authService.login();
  }
  resendConfirmEmail() {
    if (this.isSubmit) {
      return;
    }
    this.isSubmit = true;
    this.baseService.postData(UserUrl.RESEND_CONFIRM_EMAIL_URL, {
      userId: this.userId,
      callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
    }).subscribe(
      (result) => {
        this.isSubmit = false;
        if (result) {
          const resData = result.json();
          if (resData.statusCode === 200) {
            this.dialogServie.openSuccessDialog({ message: resData.message });
          }
          // Process Resend email success here.
        }
      }, err => { this.isSubmit = false; }
    );
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/administration/active-link/active-link.component.ts